<template>
  <div class="redesSociais" v-if="((item.linkFacebook != null && item.linkFacebook != '') || (item.linkLinkedin != null && item.linkLinkedin != '') || (item.linkInstagram != null && item.linkInstagram != '') || (item.linkYoutube != null && item.linkYoutube != ''))">
    <div class="auto-container text-center">
      <div class="redesSociais-title">
        <div class="titulo" v-html="fc_getText(null, 'sloganRedesSociais')"></div>
        <ul class="redes-socias-icones">
          <li v-if="(item.linkLinkedin != null && item.linkLinkedin != '')"><a :href="item.linkLinkedin" target="_blank"><span class="icon pi pi-linkedin"></span></a></li>
          <li v-if="(item.linkFacebook != null && item.linkFacebook != '')"><a :href="item.linkFacebook" target="_blank"><span class="icon pi pi-facebook"></span></a></li>
          <li v-if="(item.linkInstagram != null && item.linkInstagram != '')"><a :href="item.linkInstagram" target="_blank"><span class="icon pi pi-instagram"></span></a></li>
          <li v-if="(item.linkYoutube != null && item.linkYoutube != '')"><a :href="item.linkYoutube" target="_blank"><span class="icon pi pi-youtube"></span></a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: { },
  data() {
    return {
      item: {}
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      this.loaded = true;
    },
  },
  created() {},
  mounted() {
    let promises = [];
    promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'LinksSocialMedia/', method: 'GET', success: (response) => { this.item = response.item; resolve(); }, error: reject }); }));
    Promise.all(promises).then(() => { this.mt_start(); }).catch((e) => { this.fc_printErrors(e); });
  },
  unmounted() {},
};
</script>

<style scoped>
.redesSociais {
  position: relative;
  padding: 75px 0;
}
.redesSociais-title {
  position: relative;
  margin-bottom: 30px;
}
.redesSociais-title .titulo {
  position: relative;
  color: #3c4858;
  font-size: 35px;
  line-height: 50px;
  font-weight: 500;
  padding-bottom:30px;
}
.redes-socias-icones {
  position: relative;
}
.redesSociais .redes-socias-icones li {
  position: relative;
  margin-right: 17px;
  margin-bottom: 10px;
  display: inline-block;
}
.redesSociais .redes-socias-icones li a {
  position: relative;
  display: block;
  width: 80px;
  height: 80px;
  font-size: 40px;
  color: #fff;
  line-height: 80px;
  text-align: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}
.redesSociais .redes-socias-icones li a span {
  position: relative;
  display: block;
  width: 80px;
  height: 80px;
  font-size: 40px;
  color: #fff;
  line-height: 80px;
  text-align: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}
.redesSociais .redes-socias-icones li a span.pi-linkedin {
  background-color: #0e76a8;
}
.redesSociais .redes-socias-icones li a span.pi-facebook {
  background-color: #3b5998;
}
.redesSociais .redes-socias-icones li a span.pi-instagram {
  background: linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%); 
}
.redesSociais .redes-socias-icones li a span.pi-youtube {
  background-color: #a80e0e;
}
.redesSociais .redes-socias-icones li a span:hover {
  color: #ffffff;
  background: #ea7325;
  background: linear-gradient(#f62188 1%, #ffad43 100%);
  box-shadow: 0 0 20px rgba(0, 0, 0, .2);
}
</style>
